import { type ClassDictionary, type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function convertDatesToStrings(obj: ClassDictionary): ClassDictionary {
	const result: ClassDictionary = {}
	for (const key in obj) {
		const value = obj[key]
		if (value instanceof Date) {
			result[key] = value.toISOString().split('T')[0]
		} else if (typeof value === 'object' && value !== null) {
			result[key] = convertDatesToStrings(value)
		} else {
			result[key] = value
		}
	}
	return result
}

export const valToFloat = (value: string | number): number | undefined => {
	return typeof value === 'number'
		? value
		: value !== '' && value.length > 0
			? Number.parseFloat(value)
			: undefined
}

export const clearEmptyDateString = (value: string): string | undefined => {
	return value === '' ? undefined : value
}
